import StudyModule from './StudyModule';

export default StudyModule;
